/* eslint-disable jsx-a11y/alt-text */
import React, { useRef, useState } from "react";
import Button from "../../../../components/ui/Button/Button";
import { Form } from "../../../../utils/Form/Form";
import { BsFillCameraFill } from "react-icons/bs";
import { HiXMark } from "react-icons/hi2";
import { AddIcon, SearchIcon } from "../../../../assets/img";
import { useNavigate } from "react-router-dom";
import Tabs, { Tablist } from "../../../../components/ui/Tabs/Tabs";
import { useUpdateHospital } from "../../../../api/member-management/use-hostpital";
import { uploadImage } from "../../../../api/helper/upload-image";
import Modal from "../../../../components/ui/Modal/Modal";
import { useDaumPostcodePopup } from "react-daum-postcode";

const tabs = [
  {
    title: "병원 기본정보",
    id: 1,
  },
  {
    title: "병원 상세정보",
    id: 2,
  },
];

const HospitalEditForm = ({ hospital, id }) => {
  const open = useDaumPostcodePopup(
    "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
  );

  const navigate = useNavigate();
  const imageRef = useRef();
  const [images, setImages] = useState(hospital?.images);
  const [openHours, setOpenHours] = useState(hospital?.openHours);
  const [openHoursValue, setOpenHoursValue] = useState("");
  const [postalCode, setPostalCode] = useState(hospital?.postalCode);
  const [address, setAddress] = useState(hospital?.address);
  const [addressDetail, setAddressDetail] = useState(hospital?.addressDetail);
  const [currentTab, setCurrentTab] = React.useState(1);
  const { mutate: updateHospital } = useUpdateHospital(id);
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  const handleBackToDetail = () => {
    navigate(`/hospital/${id}/detail/`);
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];

    const imageData = new FormData();
    imageData.append("file", file);

    const { data: image } = await uploadImage(imageData);

    setImages([...images, image?.publicUrl]);
  };

  const handleRemoveImage = (val) => {
    const index = images.indexOf(val);
    if (index > -1) {
      images.splice(index, 1);
      setImages([...images]);
      imageRef.current.value = "";
    }
  };

  const onChangeOpenHours = (e) => {
    setOpenHoursValue(e.target.value);
  };

  const handleAddOpenHours = () => {
    if (openHoursValue !== "") {
      setOpenHours([...openHours, openHoursValue]);
      setOpenHoursValue("");
    }
  };

  const handleRemoveOpenHours = (val) => {
    const index = openHours.indexOf(val);
    if (index > -1) {
      openHours.splice(index, 1);
      setOpenHours([...openHours]);
    }
  };

  const handleSubmit = async (data) => {
    const payload = {
      ...data,
      images: images,
      openHours: openHours,
      postalCode: postalCode,
      address: address,
      addressDetail: addressDetail,
    };
    await updateHospital({
      ...payload,
      id,
    });
  };

  const handleComplete = (data) => {
    setPostalCode(data?.zonecode);
    setAddress(data?.address);
    setAddressDetail(data?.roadAddress);
  };
  const handleOpenDaum = () => {
    open({ onComplete: handleComplete });
  };

  return (
    <Form
      options={{
        defaultValues: {
          email: hospital?.email,
          name: hospital?.name,
          contact: hospital?.contact,
          postalCode: hospital?.postalCode,
          address: hospital?.address,
          addressDetail: hospital?.addressDetail,
          regNo: hospital?.regNo,
          licenseNo: hospital?.licenseNo,
          ceoName: hospital?.ceoName,
          ceoPhone: hospital?.ceoPhone,
          managerPhone: hospital?.managerPhone,
          details: hospital?.details,
          refundName: hospital?.refundName,
          refundBankName: hospital?.refundBankName,
          refundBankAccount: hospital?.refundBankAccount,
          openHours: openHours,
          images: images,
        },
      }}
    >
      {({ register, watch }) => {
        return (
          <>
            <Tabs onChangeTab={onChangeTab} currentTab={currentTab} tabs={tabs}>
              <Tablist currentTab={currentTab} index={1}>
                <>
                  <div className="flex mt-10 items-center gap-3">
                    <label
                      htmlFor="imageUpload"
                      className={`${
                        images?.length === 5
                          ? "cursor-not-allowed"
                          : " cursor-pointer"
                      } flex border border-[#dddddd] rounded-[4px] w-[80px] h-[80px]`}
                    >
                      <div className="m-auto text-[#aaaaaa]">
                        <BsFillCameraFill className="text-[24px]" />
                        <span className="text-center mx-auto">
                          {images?.length}/5
                        </span>
                      </div>
                      <input
                        ref={imageRef}
                        type="file"
                        hidden
                        id="imageUpload"
                        onChange={handleImageUpload}
                        disabled={images?.length === 5}
                      />
                    </label>
                    {/* <img src={imagePreview} width="100" height="100" /> */}
                    {images?.slice(0, 5).map((val) => {
                      return (
                        <div className="relative py-1 w-[80px] h-[80px]">
                          <div
                            onClick={() => handleRemoveImage(val)}
                            className="rounded-full absolute -right-2.5 bg-primary-blue text-white -top-2 px-1 py-1 cursor-pointer"
                          >
                            <HiXMark />
                          </div>
                          <img
                            src={val}
                            className="object-cover w-full h-full"
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-8">
                    <label className="text-[14px] font-bold" htmlFor="name">
                      병원명
                    </label>
                    <input
                      id="name"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="병원명을 입력하세요."
                      {...register("name")}
                      defaultValue={hospital?.name}
                    />
                  </div>
                  <div className="mt-8">
                    <label className="text-[14px] font-bold" htmlFor="zip_code">
                      주소
                    </label>
                    <div className="relative">
                      <input
                        id="zip_code"
                        className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                        placeholder="우편번호"
                        value={postalCode || ""}
                        defaultValue={hospital?.postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                      />
                      {/* <Modal
                        maxWidth="w-[40rem]"
                        description={
                          <DaumPostcodeEmbed
                            onComplete={handleComplete}
                            scriptUrl="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
                          />
                        }
                      > */}
                      <img
                        onClick={handleOpenDaum}
                        src={SearchIcon}
                        className="absolute right-3 top-0 w-9 h-9 cursor-pointer"
                        alt=""
                      />
                      {/* </Modal> */}
                    </div>
                    <input
                      id="address"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="주소지를 입력해주세요."
                      value={address || ""}
                      defaultValue={hospital?.address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    <input
                      id="addressDetail"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="상세주소를 입력해주세요."
                      value={addressDetail || ""}
                      defaultValue={hospital?.addressDetail || ""}
                      onChange={(e) => setAddressDetail(e.target.value)}
                    />
                  </div>

                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="opening_hours"
                    >
                      영업시간
                    </label>
                    {openHours?.map((val) => {
                      return (
                        <div className="relative mb-2">
                          <input
                            id="opening_hours"
                            className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                            value={val}
                          />
                          <img
                            src={AddIcon}
                            className="absolute right-3 top-0 w-9 h-9 cursor-pointer rotate-[45deg]"
                            alt=""
                            onClick={() => handleRemoveOpenHours(val)}
                          />
                        </div>
                      );
                    })}
                    <div className="relative mb-2">
                      <input
                        id="opening_hours"
                        className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                        placeholder="영업시간을 입력해주세요. (예) 평일 09:30 – 18:30"
                        onChange={onChangeOpenHours}
                        value={openHoursValue}
                      />
                      <img
                        src={AddIcon}
                        className="absolute right-3 top-0 w-9 h-9 cursor-pointer"
                        alt=""
                        onClick={handleAddOpenHours}
                      />
                    </div>
                  </div>

                  <div className="mt-8">
                    <label className="text-[14px] font-bold" htmlFor="phone">
                      전화번호
                    </label>
                    <input
                      id="phone"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="‘-’포함하여 병원 전화번호를 입력해주세요."
                      {...register("contact")}
                      defaultValue={hospital?.contact}
                    />
                  </div>

                  <div className="mt-8">
                    <label className="text-[14px] font-bold" htmlFor="details">
                      상세정보
                    </label>
                    <textarea
                      id="details"
                      rows={5}
                      className="block w-full focus:outline-none resize-none mt-4 border border-[#dddddd] p-2 rounded-[4px]"
                      placeholder="상세정보를 입력하세요."
                      {...register("details")}
                      defaultValue={hospital?.details}
                    />
                  </div>
                </>
              </Tablist>
              <Tablist currentTab={currentTab} index={2}>
                <>
                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="company_no"
                    >
                      사업자 등록번호
                    </label>
                    <input
                      id="company_no"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="사업자 등록번호를 입력하세요."
                      {...register("regNo")}
                      defaultValue={hospital?.regNo}
                    />
                  </div>

                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="license_number"
                    >
                      면허 번호
                    </label>
                    <input
                      id="license_number"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="면허 번호를 입력하세요."
                      {...register("licenseNo")}
                      defaultValue={hospital?.licenseNo}
                    />
                  </div>

                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="representative_name"
                    >
                      대표자명
                    </label>
                    <input
                      id="representative_name"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="대표자명을 입력하세요."
                      {...register("ceoName")}
                      defaultValue={hospital?.ceoName}
                    />
                  </div>
                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="representative_contract"
                    >
                      대표자 연락처
                    </label>
                    <input
                      id="representative_contract"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="연락처를 입력하세요."
                      {...register("ceoPhone")}
                      defaultValue={hospital?.ceoPhone}
                    />
                  </div>
                  <div className="mt-8">
                    <label
                      className="text-[14px] font-bold"
                      htmlFor="contact_person"
                    >
                      담당자 연락처
                    </label>
                    <input
                      id="contact_person"
                      className="mt-4 pb-1 w-full focus:outline-none border-b border-[#dddddd]"
                      placeholder="연락처를 입력하세요."
                      {...register("contact")}
                      defaultValue={hospital?.contact}
                    />
                  </div>
                </>
              </Tablist>
            </Tabs>
            <div className="mt-6 flex justify-end items-center">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지않습니다."
                onSubmit={handleBackToDetail}
              >
                <Button type="button" width="w-20 font-bold" text="목록" />
              </Modal>
              <Modal
                description="입력한 정보로 저장하시겠습니까?"
                onSubmit={() => handleSubmit(watch())}
              >
                <Button
                  text="변경완료"
                  width="w-20 font-bold"
                  textColor="text-black"
                  bgColor="bg-[#F2DCA8]"
                  borderColor="border-[#F2DCA8]"
                />
              </Modal>
            </div>
          </>
        );
      }}
    </Form>
  );
};

export default HospitalEditForm;
